export const GET_MEMBER_DETAIL_REQUESTED = 'GET_MEMBER_DETAIL_REQUESTED'
export const GET_MEMBER_DETAIL_SUCCESS = 'GET_MEMBER_DETAIL_SUCCESS'
export const GET_MEMBER_DETAIL_FAILURE = 'GET_MEMBER_DETAIL_FAILURE'
export const GET_MEMBER_SEARCH_REQUESTED = 'GET_MEMBER_SEARCH_REQUESTED'
export const GET_MEMBER_SEARCH_SUCCESS = 'GET_MEMBER_SEARCH_SUCCESS'
export const GET_MEMBER_SEARCH_FAILURE = 'GET_MEMBER_SEARCH_FAILURE'
export const CLEAN_MEMBER_DETAIL = 'CLEAN_MEMBER_DETAIL'
export const MEMBER_SEARCH_EMPTY = 'MEMBER_SEARCH_EMPTY'
export const SELECTED_MEMBER_DETAIL = 'SELECTED_MEMBER_DETAIL'
export const SELECTED_MEMBER_CLEAN = 'SELECTED_MEMBER_CLEAN'
export const SORT_BY_MEMBER_DETAIL = 'SORT_BY_MEMBER_DETAIL'

export const GET_REFERRAL_MANAGEMENT_REQUESTED =
  'GET_REFERRAL_MANAGEMENT_REQUESTED'
export const GET_REFERRAL_MANAGEMENT_SUCCESS = 'GET_REFERRAL_MANAGEMENT_SUCCESS'
export const GET_REFERRAL_MANAGEMENT_FAILURE = 'GET_REFERRAL_MANAGEMENT_FAILURE'
export const GET_REFERRAL_MANAGEMENT_SEARCH = 'GET_REFERRAL_MANAGEMENT_SEARCH'
export const EMPTY_REFERRAL_SEARCH = 'EMPTY_REFERRAL_SEARCH'
export const EXTEND_REFERRAL = 'EXTEND_REFERRAL'
export const EXTEND_REFERRAL_SUCCESS = 'EXTEND_REFERRAL_SUCCESS'
export const EXTEND_REFERRAL_FAILURE = 'EXTEND_REFERRAL_FAILURE'
export const EXTEND_REFERRAL_CLOSE_MODAL = 'EXTEND_REFERRAL_CLOSE_MODAL'
export const CLEAR_REFERRAL_MANAGEMENT = 'CLEAR_REFERRAL_MANAGEMENT'

export const GET_SPECIALTY_LIST_REQUESTED = 'GET_SPECIALTY_LIST_REQUESTED'
export const GET_SPECIALTY_LIST_SUCCESS = 'GET_SPECIALTY_LIST_SUCCESS'
export const GET_SPECIALTY_LIST_FAILURE = 'GET_SPECIALTY_LIST_FAILURE'

export const GET_AREA_OF_FOCUS_REQUESTED = 'GET_AREA_OF_FOCUS_REQUESTED'
export const GET_AREA_OF_FOCUS_SUCCESS = 'GET_AREA_OF_FOCUS_SUCCESS'
export const GET_AREA_OF_FOCUS_FAILURE = 'GET_AREA_OF_FOCUS_FAILURE'
export const CLEAN_AREA_OF_FOCUS = 'CLEAN_AREA_OF_FOCUS'

export const GET_LOCATION_REQUESTED = 'GET_LOCATION_REQUESTED'
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS'
export const GET_LOCATION_FAILURE = 'GET_LOCATION_FAILURE'

export const FIND_PROVIDERS_REQUESTED = 'FIND_PROVIDERS_REQUESTED'
export const FIND_PROVIDERS_SUCCESS = 'FIND_PROVIDERS_SUCCESS'
export const FIND_PROVIDERS_FAILURE = 'FIND_PROVIDERS_FAILURE'

export const BACK_TO_SEARCH = 'BACK_TO_SEARCH'
export const GET_PROVIDER_SEARCH = 'GET_PROVIDER_SEARCH'
export const EMPTY_PROVIDER_SEARCH = 'EMPTY_PROVIDER_SEARCH'
export const CLEAN_PROVIDER_SEARCH_ERROR = 'CLEAN_PROVIDER_SEARCH_ERROR'

export const SORT_BY_DISTANCE = 'SORT_BY_DISTANCE'
export const SORT_BY_SCORE = 'SORT_BY_SCORE'
export const SORT_BY_TOP_50_SCORE = 'SORT_BY_TOP_50_SCORE'

export const SELECT_PROVIDER_DETAIL_ASYNC = 'SELECT_PROVIDER_DETAIL_ASYNC'
export const REMOVE_SELECTED_PROVIDER_DETAIL_ASYNC =
  'REMOVE_SELECTED_PROVIDER_DETAIL_ASYNC'
export const SELECT_PROVIDER_DETAIL = 'SELECT_PROVIDER_DETAIL'
export const REMOVE_SELECTED_PROVIDER_DETAIL = 'REMOVE_SELECTED_PROVIDER_DETAIL'
export const SELECT_PROVIDER_CARE_POINT_UUID = 'SELECT_PROVIDER_CARE_POINT_UUID'
export const REMOVE_PROVIDER_CARE_POINT_UUID = 'REMOVE_PROVIDER_CARE_POINT_UUID'
export const INCREAMENT_COUNT = 'INCREAMENT_COUNT'
export const DECREAMENT_COUNT = 'DECREAMENT_COUNT'
export const SHUFFLE_SELECT_PROVIDER_CARE_POINT_UUID =
  'SHUFFLE_SELECT_PROVIDER_CARE_POINT_UUID'
export const SHUFFLE_SELECTED_PROVIDER_DETAIL =
  'SHUFFLE_SELECTED_PROVIDER_DETAIL'
export const SHUFFLE_SELECTED_PROVIDER_DETAIL_ASYNC =
  'SHUFFLE_SELECTED_PROVIDER_DETAIL_ASYNC'
export const CLEAN_PROVIDER_DETAIL = 'CLEAN_PROVIDER_DETAIL'
export const SEARCH_FOR_PROVIDER_ERRORS = 'SEARCH_FOR_PROVIDER_ERRORS'

export const PROVIDER_SUBMIT_REFERRAL = 'PROVIDER_SUBMIT_REFERRAL'
export const PROVIDER_SUBMIT_REFERRAL_REQUEST =
  'PROVIDER_SUBMIT_REFERRAL_REQUEST'
export const PROVIDER_SUBMIT_REFERRAL_SUCCESS =
  'PROVIDER_SUBMIT_REFERRAL_SUCCESS'
export const PROVIDER_SUBMIT_REFERRAL_FAILURE =
  'PROVIDER_SUBMIT_REFERRAL_FAILURE'

export const PROVIDER_SELECTION_LIMIT_REACHED =
  'PROVIDER_SELECTION_LIMIT_REACHED'

export const PROVIDER_SELECTION_LIMIT_REACHED_REMOVE =
  'PROVIDER_SELECTION_LIMIT_REACHED_REMOVE'

export const PROVIDER_DETAILS_REQUEST_ASYNC = 'PROVIDER_DETAILS_REQUEST_ASYNC'
export const PROVIDER_DETAILS_REQUEST_SUCCESS =
  'PROVIDER_DETAILS_REQUEST_SUCCESS'
export const PROVIDER_DETAILS_REQUEST_FAILURE =
  'PROVIDER_DETAILS_REQUEST_FAILURE'
export const CLOSE_PROVIDER_DETAILS_MODAL = 'CLOSE_PROVIDER_DETAILS_MODAL'

export const SIGN_IN_USER_REQUEST_ASYNC = 'SIGN_IN_USER_REQUEST_ASYNC'
export const SIGN_IN_USER_REQUEST_SUCCESS = 'SIGN_IN_USER_REQUEST_SUCCESS'
export const SIGN_IN_USER_REQUEST_FAILURE = 'SIGN_IN_USER_REQUEST_FAILURE'
export const SIGN_OUT_USER_REQUEST = 'SIGN_OUT_USER_REQUEST'
export const CLEAN_SIGN_IN_USER_DETAIL = 'CLEAN_SIGN_IN_USER_DETAIL'

export const SSO_LOGIN_REQUEST_ASYNC = 'SSO_LOGIN_REQUEST_ASYNC'
export const SSO_LOGIN_REQUEST_FAILURE = 'SSO_LOGIN_REQUEST_FAILURE'

export const GET_PLAN_DETAIL_ASYNC = 'GET_PLAN_DETAIL_ASYNC'
export const GET_PLAN_DETAIL_REQUEST_SUCCESS = 'GET_PLAN_DETAIL_REQUEST_SUCCESS'
export const GET_PLAN_DETAIL_REQUEST_FAILURE = 'GET_PLAN_DETAIL_REQUEST_FAILURE'

export const SERVER_ERROR_FAILURE = 'SERVER_ERROR_FAILURE'

export const SERVER_ERROR_SUCCESS = 'SERVER_ERROR_SUCCESS'

export const GET_ACCESS_CODE_REQUEST = 'GET_ACCESS_CODE_REQUEST'
export const GET_ACCESS_CODE_SUCCESS = 'GET_ACCESS_CODE_SUCCESS'
export const GET_ACCESS_CODE_FAILURE = 'GET_ACCESS_CODE_FAILURE'

export const GET_FORGET_PASSWORD_REQUEST = 'GET_FORGET_PASSWORD_REQUEST'
export const GET_FORGET_PASSWORD_SUCCESS = 'GET_FORGET_PASSWORD_SUCCESS'
export const GET_FORGET_PASSWORD_FAILURE = 'GET_FORGET_PASSWORD_FAILURE'

export const CLEAN_RESET_PASSWORD = 'CLEAN_RESET_PASSWORD'

// Practice Profile
export const GET_MEDICAL_NEIGHBORHOOD_REQUEST =
  'GET_MEDICAL_NEIGHBORHOOD_REQUEST'
export const GET_MEDICAL_NEIGHBORHOOD_SUCCESS =
  'GET_MEDICAL_NEIGHBORHOOD_SUCCESS'
export const GET_MEDICAL_NEIGHBORHOOD_FAILURE =
  'GET_MEDICAL_NEIGHBORHOOD_FAILURE'

export const SEARCH_MEDICAL_NEIGHBORHOOD = 'SEARCH_MEDICAL_NEIGHBORHOOD'
export const FILTER_MEDICAL_NEIGHBORHOOD_BY_SPECIALTY =
  'FILTER_MEDICAL_NEIGHBORHOOD_BY_SPECIALTY'
export const RESET_MEDICAL_NEIGHBORHOOD_FILTERS =
  'RESET_MEDICAL_NEIGHBORHOOD_FILTERS'

export const GET_NEIGHBORHOOD_PROVIDER_DETAILS_REQUEST =
  'GET_NEIGHBORHOOD_PROVIDER_DETAILS_REQUEST'
export const GET_NEIGHBORHOOD_PROVIDER_DETAILS_SUCCESS =
  'GET_NEIGHBORHOOD_PROVIDER_DETAILS_SUCCESS'
export const GET_NEIGHBORHOOD_PROVIDER_DETAILS_FAILURE =
  'GET_NEIGHBORHOOD_PROVIDER_DETAILS_FAILURE'

// Practice Report

export const GET_PRACTICE_REPORT_REQUESTED = 'GET_PRACTICE_REPORT_REQUESTED'
export const GET_PRACTICE_REPORT_SEARCH = 'GET_PRACTICE_REPORT_SEARCH'
export const EMPTY_PRACTICE_REPORT_SEARCH = 'EMPTY_PRACTICE_REPORT_SEARCH'
export const CLEAR_PRACTICE_REPORT = 'CLEAR_PRACTICE_REPORT'
export const GET_PRACTICE_REPORT_SUCCESS = 'GET_PRACTICE_REPORT_SUCCESS'
export const GET_PRACTICE_REPORT_FAILURE = 'GET_PRACTICE_REPORT_FAILURE'

export const CLOSE_PROVIDER_DETAIL = 'CLOSE_PROVIDER_DETAIL'
export const TOGGLE_NEIGHBORHOOD_PROVIDER_FLAG =
  'TOGGLE_NEIGHBORHOOD_PROVIDER_FLAG'

export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'

export const GET_REFERRAL_MEMBER_REQUEST = 'GET_REFERRAL_MEMBER_REQUEST'
export const GET_REFERRAL_MEMBER_SUCCESS = 'GET_REFERRAL_MEMBER_SUCCESS'
export const GET_REFERRAL_MEMBER_FAILURE = 'GET_REFERRAL_MEMBER_FAILURE'
